module.exports = __webpack_public_path__ + "04_veryshort_gold.7f7a6764.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/kanai/male/layer5/04_veryshort_gold.png
// module id = 1Ga/
// module chunks = 0